<template lang="pug">
  div(:class="{'bcard-field-editted': isFieldEditted}" data-testid="card-tab-overall-pvkeywords")
    a.pull-right(href="#" @click.prevent="openModal" data-testid="-link-edit") 編集
    h5: a(href="#jbcard-collapse-keywords" data-toggle="collapse" aria-expanded="false" data-testid="-link-collapse") 検索キーワード
      |
      |
      i.fa.fa-caret-down
      i.fa.fa-caret-up
    pv-keywords-view#jbcard-collapse-keywords.collapse(v-model="keywords")

    portal(to="modal")
      form(@submit.prevent="submit")
        app-modal(type="default" v-model="modalEdit.isOpen", data-testid="bcard-pvperson-keywords-modal")
          template(slot="title") 検索キーワードの変更
          pv-keywords-form(v-model="modalEdit.value")
          template(slot="footer" slot-scope="{close}")
            button.btn.btn-primary(type="submit", data-testid="-btn-edit") 変更
            button.btn.btn-default(type="button" @click.prevent="close") キャンセル

      app-modal(v-model="modalError.isOpen" type="warning")
        template(slot="title") エラー
        h4 検索キーワードの変更に失敗しました。
        p(v-if="modalError.message") {{modalError.message}}
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-default(type="button" @click="close()") 閉じる
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import PvKeywordsView from '@/components/molecules/PvKeywordsView'
import PvKeywordsForm from '@/components/organisms/forms/PvKeywordsForm'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const PersonRepository = RepositoryFactory.get('person')

export default {
  name: 'CardTabOverallPvKeywords',
  components: { AppModal, PvKeywordsView, PvKeywordsForm },
  props: {
    /**
     * @var sid_person
     */
    value: { type: [String, Number], required: false, default: '' }
  },
  data () {
    return {
      keywords: {},
      isFieldEditted: false,
      modalEdit: {
        isOpen: false,
        value: ''
      },
      modalError: {
        isOpen: false,
        message: ''
      }
    }
  },
  watch: {
    value (id) {
      if (id) {
        this.getData(id)
      }
    }
  },
  created () {
    if (this.value) {
      this.getData(this.value)
    }
  },
  methods: {
    getData (id) {
      const vm = this
      PersonRepository.getKeywords(id)
        .then(function (response) {
          const data = vm.getApiData(response).data
          vm.keywords = data
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '検索キーワードが取得できませんでした。'
          vm.showToast(message, { type: 'danger' })
          // vm.setErrorMessage(error)
        })
    },
    openModal () {
      this.modalEdit.value = Object.assign({}, this.keywords) // 参照コピーではなく値コピー
      this.modalEdit.isOpen = true
    },
    submit () {
      const vm = this
      const id = this.value
      const keywords = this.modalEdit.value
      this.isFieldEditted = false
      PersonRepository.putKeywords(id, keywords)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.keywords = Object.assign({}, vm.modalEdit.value) // 参照コピーではなく値コピー
            vm.showToast('検索キーワードを変更しました。', { type: 'success' })
            vm.modalEdit.isOpen = false
            vm.isFieldEditted = true
          }
        })
        .catch(function (error) {
          vm.modalError.message = error.message
          vm.modalError.isOpen = true
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/box/CardTabOverallPvKeywords.vue